// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from '../supports/dms-common';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import PrintIcon from '@mui/icons-material/Print';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


function PrintIndexDialog(props) {

  const { open, onClose, onPrintIndex, folderID } = props;

  // const allDocs = props.allDocs || [];
  const selectDocIDs = props.selectDocIDs || [];
  const searchViewDocIDs = props.currentViewDocs || [];


  const [selectedOnly, setSelectedOnly] = useState(false);
  const [includeSubfolder, setIncludeSubfolder] = useState(false);
  const [includeRights, setIncludeRights] = useState(false);
  const [includeCmt, setIncludeCmt] = useState(false);

  useEffect(() => {
    if (selectDocIDs.length == 0 && selectedOnly) {
      setSelectedOnly(false);
    }

  }, [selectDocIDs])

  useEffect(() => {
    if (folderID === DmsCommon.SEARCH_FOLDER_ID) {
      setIncludeSubfolder(false);
    }
  }, [folderID])

  const handleCloseClick = () => {
    onClose && onClose();
  }

  const handlePrintIndexClick = (AExportExcel) => {
    let vPrintDocs = (selectedOnly == true) ? selectDocIDs : [];
    if (folderID === DmsCommon.SEARCH_FOLDER_ID) {
      vPrintDocs = (selectedOnly == true) ? selectDocIDs : searchViewDocIDs;
    }

    onPrintIndex && onPrintIndex(folderID, vPrintDocs, includeSubfolder, includeRights, includeCmt, AExportExcel);
  }


  return (

    // <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
    //   <CssBaseline />
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={open}
      onClose={handleCloseClick}
      aria-describedby="dialog-print-doc-idx"
    >
      <DialogTitle>Print Document Index</DialogTitle>
      <DialogContent>
        <FormControl component="fieldset">

          <RadioGroup
            aria-label="range"
            value={selectedOnly ? "1" : "0"}
            onChange={(event) => setSelectedOnly(event.target.value === "1")}
            name="radio-buttons-group-range"
          >
            <FormControlLabel value="0" control={<Radio />} label="Print all documents in current view" />
            <FormControlLabel value="1" disabled={selectDocIDs.length == 0} control={<Radio />} label="Print selected documents only" />
          </RadioGroup>

          <FormControlLabel control={<Checkbox
            disabled={(folderID === DmsCommon.SEARCH_FOLDER_ID)}
            checked={includeSubfolder}
            onChange={(event) => { setIncludeSubfolder(event.target.checked) }} />}
            label="Print all documents in subfolders" />
          <FormControlLabel control={<Checkbox
            checked={includeRights}
            onChange={(event) => { setIncludeRights(event.target.checked) }} />}
            label="Print document's access right" />
          <FormControlLabel control={<Checkbox
            checked={includeCmt}
            onChange={(event) => { setIncludeCmt(event.target.checked) }} />}
            label="Print document's comment" />
        </FormControl>


      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Close</Button>
        <Button
          // startIcon={<FontAwesomeIcon icon="file-excel" /> }
          onClick={() => handlePrintIndexClick(true)}>
          Excel
        </Button>
        <Button startIcon={<PrintIcon />} onClick={() => handlePrintIndexClick(false)}>
          Print
        </Button>
      </DialogActions>
    </Dialog>

  );
}

PrintIndexDialog.propTypes = {
  open: PropTypes.bool,
  folderID: PropTypes.number,
  currentViewDocs: PropTypes.array,
  selectDocIDs: PropTypes.array,
  onClose: PropTypes.func,
  onPrintIndex: PropTypes.func,
};

export default PrintIndexDialog